import { render, staticRenderFns } from "./CustomerCustomFieldsModal.vue?vue&type=template&id=31c896b4&"
import script from "./CustomerCustomFieldsModal.vue?vue&type=script&lang=js&"
export * from "./CustomerCustomFieldsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports